// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Oztx","gfeWrapper":"CalendarEvent_gfeWrapper__3Yxcb"};